var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_5823)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_895_5823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.375 28.125V25.875H43V28.125H37.375ZM39.25 39L34.7125 35.625L36.0625 33.825L40.6 37.2L39.25 39ZM36.175 20.1375L34.825 18.3375L39.25 15L40.6 16.8L36.175 20.1375ZM17.875 37.5V31.5H15.25C14.625 31.5 14.0937 31.2812 13.6562 30.8438C13.2188 30.4063 13 29.875 13 29.25V24.75C13 24.125 13.2188 23.5937 13.6562 23.1562C14.0937 22.7188 14.625 22.5 15.25 22.5H22L29.5 18V36L22 31.5H20.125V37.5H17.875ZM31 32.025V21.975C31.675 22.575 32.2187 23.3063 32.6312 24.1688C33.0437 25.0313 33.25 25.975 33.25 27C33.25 28.025 33.0437 28.9687 32.6312 29.8312C32.2187 30.6937 31.675 31.425 31 32.025Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_895_5823",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_5823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_895_5823",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_5823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq6);
export default __webpack_public_path__ + "static/media/pin-eq-6.80f57ef4c8e1c03908351970c1ff1109.svg";
export { ForwardRef as ReactComponent };